import React, { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import bkstApi from "../../api";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ChatCanvas from "../../common/chat/ChatCanvas";
import NewMessage from "../../common/chat/NewMessage";
import useAddChatImageToItem from "../../common/chat/useAddChatImageToItem";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import PhoneIcon from "@mui/icons-material/Phone";
import { getCustomerName } from "../../common/util";

export default function OrderChat(props) {
  const { order } = props;
  const ref = useRef(null);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(window.location.hash.includes("chat"));
  const [chat, setChat] = useState(order.customer.chat || []);

  const name = getCustomerName(order.customer);
  const items = order.items || [];
  // Disabled on EditOrder: local line-item edits can diverge from server indexes / overwrite on save.
  const canAddImageToItem = !props.disableAddImageToItem && items.length > 0;

  const { saving, handleAddImageToItem } = useAddChatImageToItem({
    hasItems: canAddImageToItem,
    getPostUrl: (itemIndex) => `/my/order/${order.id}/items/${itemIndex}/images`,
    onImageAdded: props.onImageAdded,
  });

  useEffect(() => {
    if (open) {
      bkstApi(`/my/order/${order.id}/chat`).then((res) => {
        setChat(res.data.chat);

        // remove hash
        window.history.replaceState("", "", `${window.location.pathname}`);
      });
    }
  }, [open]);

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ block: "end" });
    }
  }, [chat]);

  const handleNewMsg = (msg) => {
    const allMsgs = [...chat, msg];
    setChat(allMsgs);
  };

  const lastMsg = chat.filter((o) => o.by === "cust");
  const lastMsgTs = lastMsg && lastMsg.length > 0 && lastMsg[lastMsg.length - 1].ts;
  console.log(lastMsgTs);

  return (
    <span>
      <IconButton size="small" onClick={(e) => setOpen(true)}>
        <SmsOutlinedIcon />
      </IconButton>
      <Dialog
        fullScreen={fullScreen}
        fullWidth
        maxWidth={fullScreen ? false : "sm"}
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle style={{ margin: "0", paddingLeft: "10px", paddingRight: "5px" }}>
          <Box display="flex" alignItems="center">
            <Box flexGrow={1} sx={{ display: "flex", gap: "7px", alignItems: "center" }}>
              <Avatar sx={{ width: "32px", height: "32px" }} />
              <Typography variant="h6">{name}</Typography>
            </Box>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <IconButton
                color="inherit"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                href={`tel:${order.customer.phone}`}
              >
                <PhoneIcon />
              </IconButton>
              <IconButton color="inherit" size="small" onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent
          className="chat-bg"
          style={{ minHeight: "50vh", padding: "0", margin: "0", display: "flex" }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", flexGrow: "1" }}>
            <ChatCanvas
              chat={chat}
              items={items}
              onAddImageToItem={canAddImageToItem ? handleAddImageToItem : undefined}
              saving={saving}
              addImageLabel="Add to Order"
            />
            <Box textAlign="center" ref={ref}>
              <Chip label="VIEW ORDER" color="primary" onClick={() => setOpen(false)} />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            margin: 0,
            border: 0,
            paddingBottom: "10px",
            paddingRight: "10px",
            paddingLeft: 0,
            paddingTop: 0,
          }}
        >
          <Box sx={{ flexGrow: "1" }}>
            <NewMessage
              handleNewMsg={handleNewMsg}
              uploadFolder={`img/o/${order.id}`}
              postUrl={`/my/order/${order.id}/chat`}
              lastMsgTs={lastMsgTs}
            />
          </Box>
        </DialogActions>
      </Dialog>
    </span>
  );
}
